export const EnumConciliationStatus = {
    CORTANDO: "CORTANDO",
    A_CONCILIAR: "A_CONCILIAR",
    CONCILIANDO: "CONCILIANDO",
    CONCILIADO: "CONCILIADO",
    CONCLUINDO: "CONCLUINDO",
    ERRO: "ERRO",
} as const;
  
  